import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  InvoiceIngestParseResponse,
  InvoiceIngestApplyRequest,
  InvoiceIngestApplyResponse,
} from '@stfors/shared-types';
import { api } from '../client';

export interface InvoiceIngestParseFile {
  filename: string;
  content_base64: string;
}

export function useParseInvoicePdfs() {
  return useMutation({
    mutationFn: (files: InvoiceIngestParseFile[]) =>
      api.post<InvoiceIngestParseResponse>('/api/invoices/ingest/parse', { files }),
  });
}

export function useApplyInvoiceIngest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: InvoiceIngestApplyRequest) =>
      api.post<InvoiceIngestApplyResponse>('/api/invoices/ingest/apply', body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['invoices'] });
      void qc.invalidateQueries({ queryKey: ['documents'] });
    },
  });
}
